import { message } from 'ant-design-vue'
import Vue from 'vue'
/**
 * @description 判断对象是否为空，为空返回相应提醒
 * @param {Object} obj   表单对象
 * @param {Array} list  返回的 message 提示信息
 * @returns {string|null}
 */
Vue.prototype.objNaN = function(obj, list) {
  if (obj !== '') {
    let x = 0
    for (const key in obj) {
      if (obj[key] === null || obj[key] === '') {
        message.error(list[x])
        return true
      }
      x++
    }
    return false
  }
}
/**
 * @description 时间戳转换
 * @param filterTime
 * @returns {string|null}
 */
Vue.prototype.filterTime = function(time, number) {
  if (!time) {
    return
  }
  const date = new Date(parseInt(time))
  const dateNumFun = num => (num < 10 ? `0${num}` : num)
  const [Y, M, D, h, m, s] = [
    // es6 解构赋值
    date.getFullYear(),
    dateNumFun(date.getMonth() + 1),
    dateNumFun(date.getDate()),
    dateNumFun(date.getHours()),
    dateNumFun(date.getMinutes()),
    dateNumFun(date.getSeconds())
  ]
  if (number === '1') {
    return `${Y}-${M}-${D}`
  } else if (number === '2') {
    return `${Y}-${M}-${D} ${h}:${m}`
  } else if (number === '' || number === null || number === undefined) {
    return `${Y}-${M}-${D} ${h}:${m}:${s}` // 一定要注意是反引号，否则无效。
  }
}
// 将后端特殊时间格式2019-01-03T00:18:21.000+0000转成标准时间
Vue.prototype.FilterDataTime = function(dateTime) {
  var date = new Date(dateTime).toJSON()
  return new Date(+new Date(date) + 8 * 3600 * 1000)
    .toISOString()
    .replace(/T/g, ' ')
    .replace(/\.[\d]{3}Z/, '')
}
/**
 * @description boole 转 string
 * @returns {string|null}
 */
Vue.prototype.ISBoolean = function(date) {
  return date === false ? '0' : '1'
}
/**
 * @description   string转boole
 * @param date
 * @returns {string|null}
 */
Vue.prototype.ISString = function(date) {
  return date === 1
}
/**
 * @description 富文本将转义字符转换
 * @param htmlUnescape
 * @returns {string|null}
 */
export function htmlUnescape(html) {
  return html
    .replace(html ? /&(?!#?\w+;)/g : /&/g, '&amp;')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, ' ')
    .replace(/nbsp;/g, ' ')
    .replace(/&#39;/g, "'")
}

/**
 * 图片转为base64格式
 * @param {String} dataUrl - dataUrl地址
 * @param {String} fileName - file文件名
 */
export function imageToBase64(img) {
  // Vue.prototype.$imageToBase64 = img => { //定义全局
  var canvas = document.createElement('canvas')
  canvas.width = img.width
  canvas.height = img.height
  var ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, img.width, img.height)
  var ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
  var dataURL = canvas.toDataURL('image/jpeg' + ext)
  return dataURL
}
